module.exports = __webpack_public_path__ + "img/user.ef58ee03.svg";